import { render, staticRenderFns } from "./FifthTab.vue?vue&type=template&id=2796fc1c&scoped=true"
import script from "./FifthTab.vue?vue&type=script&lang=js"
export * from "./FifthTab.vue?vue&type=script&lang=js"
import style0 from "./FifthTab.vue?vue&type=style&index=0&id=2796fc1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2796fc1c",
  null
  
)

export default component.exports